import React from "react";
import classNames from "classnames";
import Icon from "../../Icon/Icon";
import trashIcon from "icons/trash.svg";


export default class ECouponBet extends React.PureComponent {
  constructor(props) {
    super(props);

    this.initialProps = props;

    this.state = {
      removed: false,
      changed: false,
      changeDirection: false
    };
  }

  componentDidUpdate(oldProps) {
    if (typeof this.props.betName === "undefined") {
      this.setState({ removed: true });
      return;
    }

    if (this.props.accepted !== oldProps.accepted && this.props.accepted) {
      this.initialProps = this.props;
      this.setState({ changed: false });
    }

    //TODO:
    if (this.props.cf !== this.initialProps.cf) {
      const changeDirection = this.props.cf < this.initialProps.cf ? "down" : "up";

      if (this.state.changed === false || this.state.changeDirection !== changeDirection) {
        if (this.props.cf < this.initialProps.cf) {
          this.props.onBetChange(this.props.betId);
        } else {
          this.initialProps = this.props;
        }

        this.setState({ changed: true, changeDirection });
      }
    }

    if (this.props.cf !== oldProps.cf) {
      this.props.onBetCfChange(this.props.betId, this.props.cf);
    }
  }

  onRemove = () => {
    this.props.onRemove(this.props.marketId, this.props.betId);
  }

  render() {
    const removed = typeof this.props.betName === "undefined";
    const changed = this.state.changed || removed;
    const { betName, title, cf, eventName, isLive, color } = !removed ? this.props : this.initialProps;
    const { changeDirection } = this.state;

    return (
      <div className={ classNames("e-coupon-bet", color, { changed }, { removed }, changed ? changeDirection : "") }>
        <div className="e-coupon-bet__event-info">
          <span className="e-coupon-bet__event-name">{ eventName }</span>
          { isLive && (<span className="e-coupon-bet__is-live">Live</span>) }
        </div>
        <div className="e-coupon-bet__inner">
          <div className="e-coupon-bet__cf">
            { cf.toFixed(2) }
          </div>
          <div className="e-coupon-bet__bet-info">
            <div className="e-coupon-bet__bet-name">
              { betName }
            </div>
            <div className="e-coupon-bet__market-title">
              { title }
            </div>
            <div className="e-coupon-bet__delete" onClick={ this.onRemove }>
              <Icon glyph={ trashIcon }/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/EsportsGame/ECouponBet/ECouponBet.jsx